import { useEffect, useState } from "react";
import sidebar from "../../assets/img/sidebar.png"
import { urlBack } from "utils/urlEnpoint";

const recibirData = async (url) => {
    try {
        const resp = await fetch(url, {
            method: "GET",
            // body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                // "Authorization": `Bearer ${token}`
            },
            mode: "cors",
        });

        if (!resp.ok) {
            const errorText = await resp.text();
            throw new Error(`Error en la respuesta del servidor: ${resp.status} ${errorText}`);
        }

        return await resp.json();
    } catch (error) {
        console.error("Error al enviar los datos:", error);
        return { error: error.message };
    }
};


function Masleido() {

    const [loader, setLoader] = useState(false)
    const [publicaciones, setPublicaciones] = useState([])
    const getPublicaciones = async () => {
        try {
            setLoader(true);
            const respJson = await recibirData(`${urlBack}publicaciones.php`);

            const primerosTres = respJson?.data?.slice(0, 3) || [];

            setPublicaciones(primerosTres);

        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        let isMounted = true
        if (isMounted) {
            getPublicaciones()
        }

        return () => {
            isMounted = false
        }
    }, [])

    return (
        <div className='width-30 ms-4 w-responsive margin-hide-mobile'>

            <div className='text-blue'>LAS MÁS LEIDAS</div>
            {loader ?
                <div className="d-flex flex-column align-items-center justify-content-center mt-4">
                    <span className="loader"></span>
                    <div className="text-small text-blue mt-2">Cargando</div>
                </div>

                :
                <>
                    {publicaciones.map((noticia , i) => {
                        return (
                            <div key={i} className='mt-3 '>
                                <div className='d-flex '>
                                    <div className='text-medium text-blue mx-3 '>{i+1}</div>
                                    <div>
                                        <div>{noticia.titulo}</div>
                                        <div className='mt-3 text-small'><span className='text-bold'>Autor: </span>Observador Minero</div>
                                    </div>
                                </div>
                                <div className={i === 2 ?'hide-responsive':' borderBottom-blue'}></div>
                            </div>
                        )
                    })}

                </>
            }
            <div className="mt-5"><img className="w-100 hide-responsive" src={sidebar} alt="sidebar" /></div>
        </div>
    )
}

export default Masleido